export const LAST_VISITED_COUNTERPARTIES = "last-visited-counterparties";
export const LAST_SELECTED_SIGNATURES = "last-selected-signatures";
export const PERMISSIONS_STORAGE_KEY = "permissions";
export const SERVICES_FILTER_BY_CURRENT_EMPLOYEE_WORKFLOW_ROLES = "services-filter-by-current-employee-workflow-roles";
